import {
    deleteStudentFormById
} from "../../_services/student_form.service";

export const deleteStudentFormByIdEvent = async (id) => {
    return await deleteStudentFormById(id);
}
